import { render, staticRenderFns } from "./PlanFactSummary.vue?vue&type=template&id=3440c0a4&"
import script from "./PlanFactSummary.vue?vue&type=script&lang=js&"
export * from "./PlanFactSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports